module.exports = __webpack_public_path__ + "images/emoji/koko.3465e344664c35a5fb5b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/koko.png
// module id = FFYh
// module chunks = 24